<template lang="pug">
.address-form
  AddressSearchUK
  template(v-if="epcData")
    HouseInfoFormUK(v-if="showHouseForm")
    TermsAgreement
</template>
<script lang="ts">
import { defineComponent, ref } from "vue";
import AddressSearchUK from "@/components/forms/questions/address/AddressSearchUK.vue";
import { LayoutEvent, on } from "@/helpers";
import { storeToRefs } from "pinia";
import { useSelections } from "@/store";
import HouseInfoFormUK from "./questions/general/HouseInfoFormUK.vue";
import TermsAgreement from "./questions/TermsAgreement.vue";
export default defineComponent({
  name: "AddressForm",
  components: {
    AddressSearchUK,
    HouseInfoFormUK,
    TermsAgreement,
  },
  setup() {
    const { epcData } = storeToRefs(useSelections());
    const showHouseForm = ref(false);
    on(LayoutEvent.ShowHouseInfoForm, (val: boolean) => (showHouseForm.value = val));
    return {
      showHouseForm,
      epcData,
    };
  },
});
</script>
<style scoped lang="scss"></style>
